export default {
  getToken: state => state.token,
  getAuthorizationStatus: state => state.authorizationStatus,
  getLocale: state => state.locale,
  getSelectedSignatureProvider: state => state.selectedSignatureProvider,
  getSelectedSignatureProviderHasEmailAuth: state => {
    if (state.selectedSignatureProvider.hasOwnProperty('emailAuth')) {
      return state.selectedSignatureProvider.emailAuth
    } else {
      return false
    }
  },
  getSelectedSignatureProviderHasPhoneAuth: state => {
    if (state.selectedSignatureProvider.hasOwnProperty('phoneAuth')) {
      return state.selectedSignatureProvider.phoneAuth
    } else {
      return false
    }
  },
  getSelectedSignatureProviderHasUsernameAuth: state => {
    if (state.selectedSignatureProvider.hasOwnProperty('usernameAuth')) {
      return state.selectedSignatureProvider.usernameAuth
    } else {
      return false
    }
  },
  getSelectedSignatureProviderHasOtp: state => {
    if (state.selectedSignatureProvider.hasOwnProperty('otp')) {
      return state.selectedSignatureProvider.otp
    } else {
      return false
    }
  },
  getSelectedSignatureProviderRequiresOtp: state => {
    if (state.selectedSignatureProvider.hasOwnProperty('requiresOtp')) {
      return state.selectedSignatureProvider.requiresOtp
    } else {
      return false
    }
  },
  getSignatureProviders: state => state.signatureProviders,
  getInternalSignatureProviders: state => state.internalSignatureProviders,
  getUploadedDocument: state => state.uploadedDocument,
  getUploadedDocumentInfo: state => state.uploadedDocumentInfo,
  getshowPdfPrv: state => state.showPdfPrv
}
